<template>
	<router-view/>
</template>

<script>
// import AwardTable from "../components/about/AwardTable"
// import TeamStatic from "../components/about/TeamStatic"
// import PageIntroSection from '../components/page/PageIntroSection'
// import {TimelineLite} from 'gsap/all'
// import WorkSlideContent from '../components/works/WorkSlideContent'
// import TeamSlideContent from '../components/about/TeamSlideContent'

export default {
	name: 'works',
	// data() {
	// 	return {
	// 		// animation
	// 		appearTl: new TimelineLite({paused: 1}),
	// 		// slider
	// 		worksSlides: [
	// 			{
	// 				component: WorkSlideContent,
	// 				props: {
	// 					thumbnailImgFilename: 'works-slide-thumbnail-tanakan.jpg',
	// 					index: 1,
	// 					title: 'Tanakan for RBK',
	// 					href: 'works/tanakan',
	// 				},
	// 			},
	// 			{
	// 				component: WorkSlideContent,
	// 				props: {
	// 					thumbnailImgFilename: 'works-slide-thumbnail-tanakan.jpg',
	// 					index: 2,
	// 					title: 'Tanakan for RBK',
	// 					href: 'works/tanakan',
	// 				},
	// 			},
	// 		],
	// 	}
	// },
	// mounted() {
	// 	this.appearTl.fromTo(this.$el, .5, {
	// 		autoAlpha: 0,
	// 	}, {
	// 		autoAlpha: 1,
	// 	})
	// 	// slow mo
	// 	this.appearTl.timeScale(this.$const.ANIMATION_SLOW_MO)
	// },
	// watch: {
	// 	'$store.state.isPreloaderHide'(value) {
	// 		if (value) {
	// 			this.appearTl.play()
	// 		}
	// 	},
	// },
}
</script>

<style lang="scss">
// wrap overflow up
$overflowUpScreen: 70;
$overflowUpMobile: 54px;

// case page wrap
.ww {
	> section {
		// video section
		&:nth-child(2) {
			padding-top: 0;
			@include space-responsive-padding-b(140 - $overflowUpScreen);
			// container
			> div {
				transform: translateY(responsive-size-height-screen(-$overflowUpScreen));
				// mobile
				@include breakpoint($mobileDesignBreakpoint) {
					transform: translateY(-1*$overflowUpMobile);
				}
			}
			// mobile
			@include breakpoint($mobileDesignBreakpoint) {
				padding-bottom: 0;
			}
		}
		// nav section
		&:last-child {
			// next link
			a {
				line-height: 1;
				// icon
				svg {
					height: .7em;
				}
			}
		}
		// images
		picture {
			width: 100%;
		}
	}
}

// awards wrap
.aw {
	@include space-responsive-margin-t(230);
	display: flex;
	align-self: flex-end;
	// mobile
	@include breakpoint($mobileDesignBreakpoint) {
		align-self: flex-start;
		margin-top: 0;
		margin-bottom: 135px;
	}
	// one award wrap
	> div {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		width: responsive-size-width-screen(38);
		// margin between
		&:not(:first-child) {
			@include space-responsive-margin-l(18);
		}
		// mobile
		@include breakpoint($mobileDesignBreakpoint) {
			width: 30px;
			&:not(:first-child) {
				margin-left: 15px;
			}
		}
		// text
		> p {
			position: absolute;
			cursor: default;
		}
		// icon
		picture {
			width: 100%;
			svg {
				path {
					fill: none;
					stroke: var(--gray);
				}
			}
		}
	}
}

// links wrap
.lw {
	span {
		display: inline-block;
		&:nth-child(n+2) {
			@include space-responsive-margin-l(40);
			// mobile
			@include breakpoint($mobileDesignBreakpoint) {
				margin-left: 0;
				margin-top: 8px;
				display: block;
			}
		}
	}
}
</style>
